import { TTypeOfCodec } from "../../../shared/src/codecs/codec";
import { formIO, TFormIOCodec } from "../../../shared/src/codecs/types/formIO";
import { required, TRequiredCodec } from "../../../shared/src/codecs/types/required";
import { uuid, TUuidCodec } from "../../../shared/src/codecs/types/uuid";
import { string } from "../../../shared/src/codecs/types/string";
import { TAnyUnionCodec, union } from "../../../shared/src/codecs/types/union";
import { nullCodec } from "../../../shared/src/codecs/types/nullCodec";

type TListingValSubmitInputCodec = TRequiredCodec<{
    listing_id: TUuidCodec;
}>;

type TListingValSubmitOutputCodec = TRequiredCodec<{
    val_case_id: TAnyUnionCodec;
    val_case_status: TAnyUnionCodec;
}>;

export const ListingValSubmitFormIO: TFormIOCodec<
    TListingValSubmitInputCodec,
    TListingValSubmitOutputCodec
> = formIO(
    required({ listing_id: uuid() }),
    required({
        val_case_id: union([nullCodec(), string()]),
        val_case_status: union([nullCodec(), string()]),
    }),
);

export type TListingValSubmitFormIOCodec = typeof ListingValSubmitFormIO;
export type TListingValSubmitFormIO = TTypeOfCodec<TListingValSubmitFormIOCodec>;
